import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from '../icon/svg/upgrade-arrow-icon';
import {Body} from '../typography/body';

import styles from './upgrade-pill-button.module.css';

export type UpgradePillProps = {
    size?: 'small' | 'normal';
    onClick: () => void;
    dataTip?: string;
};

type Props = {
    onClick: () => void;
    size?: 'small' | 'normal';
    dataTip?: string;
};

export function UpgradePillButton(props: Props) {
    const {size = 'normal'} = props;

    return (
        <button onClick={props.onClick} data-tip={props.dataTip} className={styles['pill-wrapper']}>
            <UpgradeArrowIcon
                wrapWithDiv={false}
                size={size === 'normal' ? 20 : 14}
                color={colors.blue}
                alignCenter={true}
            />
            <Body color='blue' size={size}>
                Upgrade
            </Body>
        </button>
    );
}
